module.exports = __webpack_public_path__ + "default-author-image-d00b9a7c7ed081f933c7.png";